@if (institutionId > 0 && showModule) {
  <div id="submodule-orders" class="cw-module-card">
    @if (!showOrderDetails) {
      <div>
        <!-- Header -->
        <div class="cw-flex-row">
          <h2>{{ 'GENERAL.ORDERS' | translate }}</h2>
          <!-- Toolbar -->
          @if (!showOrderDetails) {
            <phscw-toolbar
              componentIdentifier="institutions-orders"
              [componentConnection]="$any(this)"
              [buttonAdd]="true"
              buttonAddTooltip="{{ 'MODULES.INSTITUTIONS.ORDERS.ADDNEW' | translate }}"
              printContent="submodule-orders">
            </phscw-toolbar>
          }
        </div>
        <!-- Grid um Aufträge der Einrichtung anzuzeigen (editMode = false) -->
        @if (!showOrderDetails) {
          <phscw-grid
            #gridInstitutionsOrders
            gridId="institutionsOrders"
            [simpleGrid]="true"
            [gridData]="data"
            [gridColumns]="gridColumns"
            [gridDisplayedColumns]="gridDisplayedColumns">
          </phscw-grid>
        }
        <!-- Funktion um weitere Einträge zu laden -->
        @if (!showOrderDetails) {
          <phscw-grid-load-more
            gridId="institutionsOrders"
            [enabled]="loadMoreEnabled"
            [visible]="loadMoreVisible"
            [gridPageCounter]="gridPage">
          </phscw-grid-load-more>
        }
      </div>
    }
    <!-- Auftragserfassung (showOrderDetails = false) -->
    @if (showOrderDetails) {
      <div>
        <phscw-order-tracking
          orderIdentifier="institutionsOrders"
          [institutionAndOrderId]="{orderId: orderId, institutionId: institutionId}"
          [editMode]="editMode"
          (changeShowOrderDetailsMode)="showOrderDetails = $event"
          (submitOrder)="loadData($event)"
          [exclusiveDiscounts]="exclusiveDiscounts">
        </phscw-order-tracking>
      </div>
    }
  </div>
}

@if (institutionId > 0 && !showModule) {
  <div id="submodule-orders-notShow" class="cw-module-card">
    <div class="cw-flex-row">
      <h2>{{ 'GENERAL.ORDERS' | translate }}</h2>
    </div>
    <div>{{ 'MODULES.INSTITUTIONS.ORDERS.PERMISSIONNOTICE' | translate }}</div>
  </div>
}
